import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = "";

const specialSlice = createSlice({
  name: "specialCode",
  initialState,
  reducers: {
    setSpecial(state, action: PayloadAction<string>) {
      state = action.payload;

      return state;
    },
  },
});

const { reducer, actions } = specialSlice;
export const { setSpecial } = actions;
export default reducer;
